import { Check, Code2, Globe, Smartphone, Sparkles, Server } from "lucide-react";
import { SERVICES } from "../lib/content";

const ICONS = {
  software: Code2,
  web: Globe,
  mobile: Smartphone,
  ai: Sparkles,
  devops: Server,
};

const SIZE_CLASSES = {
  lg: "md:col-span-8 md:row-span-2",
  md: "md:col-span-8",
  sm: "md:col-span-4",
};

export const Services = () => {
  return (
    <section
      id="servicios"
      data-testid="services-section"
      className="bg-[#FAFAFA] py-24 md:py-32 relative"
    >
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div>
            <div className="font-mono text-xs uppercase tracking-[0.25em] text-orange-600 mb-4">
              <span>{`{ `}</span>servicios<span>{` }`}</span>
            </div>
            <h2 className="font-display font-extrabold text-4xl md:text-5xl lg:text-6xl tracking-tight text-slate-900 max-w-3xl">
              Un solo equipo para todo tu <span className="text-purple-700">stack digital</span>.
            </h2>
          </div>
          <p className="text-slate-600 max-w-md text-base md:text-lg">
            Desde la idea hasta producción, diseñamos soluciones que escalan con tu negocio y
            conversan con tus procesos actuales.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-8 lg:grid-cols-12 gap-4 md:gap-6 auto-rows-fr">
          {SERVICES.map((s, idx) => {
            const Icon = ICONS[s.key] || Code2;
            const span =
              s.size === "lg"
                ? "md:col-span-8 lg:col-span-8 lg:row-span-2"
                : s.size === "md"
                ? "md:col-span-8 lg:col-span-8"
                : "md:col-span-4 lg:col-span-4";
            return (
              <article
                key={s.key}
                data-testid={`service-card-${s.key}`}
                className={`group relative bg-white border border-slate-200 rounded-xl p-7 md:p-8 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:border-purple-200 flex flex-col ${span}`}
              >
                {s.badge && (
                  <span className="absolute top-5 right-5 font-mono text-[10px] tracking-widest uppercase text-orange-600 bg-orange-50 border border-orange-200 px-2 py-1 rounded-full">
                    {s.badge}
                  </span>
                )}
                <div className="h-12 w-12 rounded-lg bg-purple-50 text-purple-700 border border-purple-100 flex items-center justify-center mb-6 group-hover:bg-purple-700 group-hover:text-white transition-colors">
                  <Icon size={22} />
                </div>
                <h3 className="font-display font-bold text-2xl md:text-3xl text-slate-900 tracking-tight">
                  {s.title}
                </h3>
                <p className="mt-3 text-slate-600 text-base leading-relaxed flex-1">
                  {s.description}
                </p>
                <ul className="mt-6 flex flex-wrap gap-2">
                  {s.bullets.map((b) => (
                    <li
                      key={b}
                      className="inline-flex items-center gap-1.5 text-xs font-mono text-slate-600 bg-slate-50 border border-slate-200 rounded-full px-2.5 py-1"
                    >
                      <Check size={12} className="text-orange-600" /> {b}
                    </li>
                  ))}
                </ul>
                <span className="absolute left-0 top-0 h-[3px] w-0 bg-gradient-to-r from-purple-600 to-orange-500 group-hover:w-full transition-all duration-500" />
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
